import { Component, Input, OnInit } from '@angular/core';
import { ProfileService } from 'app/core/services/profile.service';
import { CompareType } from 'app/shared/components/ag-grid-dynamic/grid-types';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { FieldTypes, statusPayment } from 'app/shared/model/enums';
import { CommonService } from 'app/shared/services/common.service';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

export  abstract class PaymentsBase{
  bussinessid;
  listPayments$: Observable<any>;
  columns;
  stripePayment;
  totalRecords:number;
  dt22: string;
  filters: any[] = [];
  ErrorCode;
  message;
  constructor(private profileService: ProfileService, private messageService: MessageService, private localizationService: LocalizationService) { }

   Init(): void {
    this.initTable()
    this.fillData();
  }
  fillData() {
    this.stripePayment = null;

    this.listPayments$ = this.profileService.getPayments(this.bussinessid)
      .pipe(tap(res => {
        this.ErrorCode = res.ErrorCode;
        if (res.ErrorCode) {
          if (this.ErrorCode == 1) {
            this.message = this.localizationService.Translate("PAYMENTS_DETAILS.NO_RECORDS_FOUND");
          }
        }
      }))
      .pipe(map(res => res.StripePayment));
  }
   initTable() {
    this.columns = [
      {
        field: 'NameProduct',
        headerTranslate: "PAYMENTS_DETAILS.NAME_PRODUCT",
        width: '5%',
        filterMatchMode: CompareType.contains,
      },
      {
        field: 'CreateDate',
        headerTranslate: "PAYMENTS_DETAILS.CREATE_DATE",
        width: '5% !important',
        type: FieldTypes.date,
        filterMatchMode: CompareType.contains,
      },
      {
        field: 'Amount',
        headerTranslate: "PAYMENTS_DETAILS.AMOUNT",
        width: '5% !important',
        type: FieldTypes.sumWithCurrency,
        currencyFieldName: 'Currency',
        filterMatchMode: CompareType.contains,
      },
      {
        field: 'Card4',
        headerTranslate: "PAYMENTS_DETAILS.CARD4",
        width: '5% !important',
        filterMatchMode: CompareType.contains,
      },
      {
        field: 'NameCard',
        headerTranslate: "PAYMENTS_DETAILS.NAME_CARD",
        width: '5%',
        filterMatchMode: CompareType.contains,
      },
      {
        field: 'RecieptNumber',
        headerTranslate: "PAYMENTS_DETAILS.RECIEPT_NUMBER",
        width: '5%',
        filterMatchMode: CompareType.contains,
      },
      {
        field: 'Status',
        headerTranslate: "PAYMENTS_DETAILS.STATUS",
        width: '5%',
        filterMatchMode: CompareType.contains,
        type: FieldTypes.enumComboBox,
        enumType: statusPayment,
        enumName: 'StatusName'

      },
      {
        field: 'UrlPayment',
        headerTranslate: "PAYMENTS_DETAILS.RECEIPT",
        linkDescription: "PAYMENTS_DETAILS.RECEIPT",
        width: '5%',
        type: FieldTypes.link,
        isDisplay: 'UrlPayment'
      },
      {
        field: 'UrlInvoice',
        headerTranslate: "PAYMENTS_DETAILS.INVOICE",
        linkDescription: "PAYMENTS_DETAILS.INVOICE",
        width: '5%',
        filterMatchMode: CompareType.contains,
        type: FieldTypes.link,
        isDisplay: 'UrlInvoice'
      },
    ];
  }
}